import React from 'react';
import { SharedBarChart } from '../../charts/SharedBarChart';
import { reportRowsToChartData } from '../../charts/chartAdapters';

export function BarChartBlock({ data }) {
    const rows = data?.rows || [];

    if (rows.length === 0) {
        return <p className="no-data">Sin datos para mostrar</p>;
    }

    const chartData = reportRowsToChartData(rows);

    return (
        <div className="bar-chart-block">
            <SharedBarChart chartData={chartData} height={300} />
        </div>
    );
}
